import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = ({ className = '' }) => {
  const classes = useStyles();

  return (
    <Box className={`${classes.container} ${className}`}>
      <Box className="comment-avatar">
        <Skeleton variant="circle" width="100%" height="100%" />
      </Box>
      <Box className="comment-content" flexGrow={1}>
        <Box className="comment-ballon">
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="text" width="50%" />
        </Box>
        <Box className="comment-footer">
          <Box className="comment-footer-date">
            <Skeleton variant="text" width="200px" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Loading;
